/* Auguzt — Intro screen controller.
   The intro is a transparent overlay on the real enter page (see
   auguzt-intro.css). On a game-button press it plays a synthesized sound and
   a CRT turn-off / turn-on on the enter page's own picture (.wrapper), then
   reveals the icon grid. Both buttons do the same thing: enter the site.
   The sound is Web Audio synthesis (no asset): a crisp "select" click + a
   short confirm arpeggio + sub thump, then a CRT power-on sweep with a bright
   ping timed to the turn-on flash. */
(function () {
  var intro = document.getElementById("AuguztIntro");
  if (!intro) return;

  var html = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var soundOn = intro.getAttribute("data-auguzt-intro-sound") !== "false";
  var started = false;

  /* ---------------------------------- audio -------------------------------- */
  var actx = null;
  function ac() {
    if (!actx) {
      try { actx = new (window.AudioContext || window.webkitAudioContext)(); }
      catch (e) { actx = null; }
    }
    if (actx && actx.state === "suspended") actx.resume();
    return actx;
  }

  /* a pitched tone with its own gain envelope, optional lowpass sweep */
  function tone(ctx, dest, t, type, f0, f1, dur, peak, lpf0, lpf1) {
    var o = ctx.createOscillator();
    var g = ctx.createGain();
    o.type = type;
    o.frequency.setValueAtTime(f0, t);
    if (f1 && f1 !== f0) o.frequency.exponentialRampToValueAtTime(Math.max(1, f1), t + dur);
    if (lpf0) {
      var lp = ctx.createBiquadFilter();
      lp.type = "lowpass";
      lp.frequency.setValueAtTime(lpf0, t);
      if (lpf1) lp.frequency.exponentialRampToValueAtTime(Math.max(60, lpf1), t + dur);
      g.connect(lp); lp.connect(dest);
    } else {
      g.connect(dest);
    }
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(peak, t + Math.min(0.03, dur * 0.25));
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.connect(g);
    o.start(t);
    o.stop(t + dur + 0.03);
  }

  /* a filtered noise burst (click transient / CRT static) */
  function noise(ctx, dest, t, dur, peak, type, freq, q) {
    var n = Math.max(1, Math.floor(ctx.sampleRate * dur));
    var buf = ctx.createBuffer(1, n, ctx.sampleRate);
    var d = buf.getChannelData(0);
    for (var i = 0; i < n; i++) d[i] = Math.random() * 2 - 1;
    var src = ctx.createBufferSource(); src.buffer = buf;
    var f = ctx.createBiquadFilter();
    f.type = type || "bandpass";
    f.frequency.value = freq;
    f.Q.value = q || 0.8;
    var g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(peak, t + 0.008);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    src.connect(f); f.connect(g); g.connect(dest);
    src.start(t); src.stop(t + dur + 0.03);
  }

  function playEnter() {
    var ctx = ac();
    if (!ctx) return;
    var t = ctx.currentTime + 0.01;
    var master = ctx.createGain();
    master.gain.value = 0.85;
    master.connect(ctx.destination);

    /* 1) crisp "select" click */
    noise(ctx, master, t, 0.045, 0.16, "highpass", 2600, 0.7);
    tone(ctx, master, t, "square", 1180, 760, 0.05, 0.09, 2600, 1200);

    /* 2) short confirm arpeggio (A5 -> E6), bright but soft */
    tone(ctx, master, t + 0.015, "triangle", 880, 880, 0.10, 0.12, 4200, null);
    tone(ctx, master, t + 0.105, "triangle", 1318, 1318, 0.16, 0.11, 4800, null);

    /* 3) sub thump for weight */
    tone(ctx, master, t, "sine", 150, 60, 0.20, 0.5, null, null);

    /* 4) CRT power-on, timed to land with the turn-on flash (~0.5s later) */
    var on = t + 0.5;
    tone(ctx, master, on, "sawtooth", 80, 560, 0.30, 0.12, 900, 3200);  /* rising sweep */
    noise(ctx, master, on + 0.02, 0.20, 0.055, "bandpass", 5200, 0.6);  /* static shimmer */
    tone(ctx, master, on + 0.16, "sine", 1046, 1046, 0.16, 0.08, null, null); /* bright ping (C6) */
  }

  /* --------------------------- the transition ---------------------------- */
  /* timeline (ms):  0 picture squashes off  ·  500 flash + picture snaps on
                     620 icons fade in       ·  940 overlay removed           */
  function finish() {
    html.classList.remove("auguzt-intro-active");   // icons fade in
    html.classList.remove("auguzt-tv-on");
    intro.classList.add("is-done");
    intro.setAttribute("aria-hidden", "true");
  }

  function enter() {
    if (started) return;
    started = true;
    if (soundOn) { try { playEnter(); } catch (e) {} }

    if (reduce) {
      finish();
      return;
    }

    intro.classList.add("is-off");            // buttons drop out
    html.classList.add("auguzt-tv-off");      // picture collapses to a dot
    setTimeout(function () {
      html.classList.remove("auguzt-tv-off");
      html.classList.add("auguzt-tv-on");     // picture snaps back on…
      intro.classList.add("is-on");           // …behind a white flash
    }, 500);
    setTimeout(function () {
      html.classList.remove("auguzt-intro-active"); // icons fade in under the flash
    }, 620);
    setTimeout(finish, 940);
  }

  var btns = intro.querySelectorAll("[data-auguzt-intro-go]");
  for (var i = 0; i < btns.length; i++) {
    btns[i].addEventListener("click", enter);
  }
})();
